import {Component,Input,OnInit,ViewChild} from '@angular/core';
import {Prestation} from "@domain/prestation/prestation";
import {NgForm} from "@angular/forms";
import {ListView} from "@domain/common/list-view";
import {ZuListItemComponent} from "@components/admin/frais/prestations/prestation-detail/zu/zu-list-item.component";
import {TranslateService} from "@ngx-translate/core";
import {ZoneUtilisateur} from "@domain/zone-utilisateur/zone-utilisateur";
import {MatLegacyDialog as MatDialog} from "@angular/material/legacy-dialog";
import {AddZuComponent} from "@components/admin/frais/prestations/prestation-detail/zu/add-zu.component";

/**
 * Composant de l'onglet ZU d'une prestation
 */
@Component({
	selector: 'prestation-zu',
	host: {'data-test-id': 'prestation-zu'},
	templateUrl: './prestation-zu.component.html'
})
export class PrestationZuComponent implements OnInit {
	/** Prestation concernée */
	@Input() prestation : Prestation;

	/** Formulaire du composant */
	@ViewChild('form') form: NgForm;

	/** Liste des zones utilisateurs */
	listeZu: ListView<ZoneUtilisateur,ZuListItemComponent>;

	/**
	 * Constructeur
	 */
	constructor(private translateService: TranslateService,private matDialog: MatDialog) {}

	/**
	 * Initialisation du composant
	 */
	ngOnInit(): void {
		this.listeZu = new ListView<ZoneUtilisateur,ZuListItemComponent>({
			uri: `/controller/AdminPrestation/listeZoneUtilisateur/${this.prestation.idPrestation}`,
			title: this.translateService.instant('admin.frais.prestations.detail.zu.zonesUtilisateur.title'),
			component: ZuListItemComponent,
			isSearchBar: false,
			isFilter: false,
			isFilterVisible: false,
			isLocal: true,
			extraOptions: {
				refreshListe: () => this.listeZu.refresh(),
				idPrestation: this.prestation.idPrestation
			},
			listeActions: [
				{
					icon: 'add',
					onPress: () => this.addZu()
				}
			]
		});
	}

	/**
	 * Ajout d'une nouvelle ZU
	 */
	addZu() {
		//Ouverture de la boîte de dialogue pour ajouter une ZU
		this.matDialog.open(AddZuComponent, {
			width: '30%',
			data: { idPrestation: this.prestation.idPrestation }
		}).afterClosed().subscribe(zu => {
			if (zu.idZU) {
				//Rafraichissement de la liste
				this.listeZu.refresh();
			}
		});
	}
}